import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import { Field } from '../../../ui/Field';
import Select from 'react-select';
import UpdatePage from '../../../composents/UpdatePage';

const title = 'Users';
const headers = {
	icon: 'feather icon-edit',
	title: title,
	description: 'update of user',
	breadcrumbs: [
		{
			title: title,
			link: '/administrators/users',
		},
	],
};

export default function EditUser() {
	const [loader, setLoader] = useState(false),
		[errors, setErrors] = useState({}),
		{ id } = useParams(),
		[data, setData] = useState(),
		[groups, setGroups] = useState([]),
		[fail, setFail] = useState(false),
		[loading, setLoading] = useState(true),
		[group, setGroup] = useState();

	async function onGet() {
		setLoading(true);
		let user = await resources.user
			.readOne(id)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (user.status === 200) {
			setData(user.data);
		} else if (user.status === 403) {
			setFail(true);
		}

		let cus = await resources.group
			.read('all')
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (cus.status === 200) {
			let a = [];
			const data = cus.data.docs.filter(
				(e) =>
					!e.client &&
					(e.title !== 'customer' || e.role !== 'customer')
			);
			data.forEach((el) => {
				if (user.data.group === el.id) {
					setGroup({
						value: el.id,
						label: el.title + ' | ' + el.role,
					});
				}
				a.push({
					value: el.id,
					label: el.title + ' | ' + el.role,
				});
			});
			setGroups(a);
		}

		setLoading(false);
	}

	useEffect(() => {
		onGet();
	}, []);

	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onCreate(e) {
		e.preventDefault();
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));
		if (group) object.group = group.value;
		if (object.password.length === 0) {
			delete object.password;
			delete object.password_confirmation;
		}
		setLoader(true);
		setErrors({});
		let res = await resources.user
			.update(id, object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/administrators/users');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}
		setLoader(false);
	}

	return (
		<UpdatePage
			show_error={errors['not_autorized']}
			loading={loading}
			fail={fail}
			headers={headers}
		>
			<form onSubmit={onCreate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6 ">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<Field
									name="fullName"
									className="mb-3"
									error={errors['fullName']}
									defaultValue={data?.fullName}
									required
								>
									User name
								</Field>

								<Field
									type="email"
									name="email"
									className="mb-3"
									error={errors['email']}
									defaultValue={data?.email}
									required
								>
									Email
								</Field>

								<div className="form-group mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										User group{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										onChange={(e) => setGroup(e)}
										options={groups}
										isSearchable
										value={group}
										isClearable
										className={
											errors['group'] ? ' is-invalid' : ''
										}
									/>
									{errors['group'] && (
										<div className="invalid-feedback">
											{errors['group']}
										</div>
									)}
								</div>

								<Field
									name="password"
									type="password"
									className="mb-3"
									error={errors['password']}
								>
									Password
								</Field>

								<Field
									name="password_confirmation"
									type="password"
									error={errors['password_confirmation']}
									className="mb-3"
								>
									password confirmation
								</Field>

								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												class="btn waves-effect waves-light btn-primary"
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</UpdatePage>
	);
}
